var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VRow',[_c('VCol',{attrs:{"cols":"6"}},[_c('VList',[_c('VListItem',[_c('VListItemAvatar',[_c('VIcon',[_vm._v("mdi-file-outline")])],1),_c('VListItemContent',[_c('router-link',{staticClass:"mx-2",attrs:{"to":{
              name: 'legal.index',
              params: {
                type: _vm.type,
                id: _vm.venue,
              },
            },"target":"_blank"}},[_vm._v(_vm._s(_vm.label)+" URL ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }